import React, { useRef } from 'react';
import { Drawer, Grid } from '@material-ui/core';
import { Typography } from '@swagup-com/components';
import SearchBar from '../../shared/ui/searchBar';
import { shoppingExperienceColors } from '../../shared/constants';

const MobileSearch = ({ open, onClose }) => {
  const searchInputRef = useRef(null);
  const handleEntered = () => {
    if (searchInputRef.current) {
      searchInputRef.current.focus();
    }
  };

  return (
    <Drawer anchor="left" open={open} onClose={onClose} SlideProps={{ onEntered: handleEntered }}>
      <Grid container direction="column" style={{ padding: '20px 0' }}>
        <Grid container item alignItems="center" spacing={1} style={{ padding: '0 20px' }}>
          <Grid item xs>
            <SearchBar ref={searchInputRef} onClose={onClose} />
          </Grid>
          <Grid item>
            <Typography variant="body3SemiBoldInter" style={{ cursor: 'pointer' }} onClick={onClose}>
              Cancel
            </Typography>
          </Grid>
        </Grid>
        <Typography
          variant="body4ItalicInter"
          style={{ paddingTop: '10px', marginLeft: '30px', color: shoppingExperienceColors.info }}
        >
          Search by name, keyword, or phrase, only the dash (-) special character is supported
        </Typography>
      </Grid>
    </Drawer>
  );
};

export default MobileSearch;
